import React from "react";

const AccountingGeneralLedgerTab = () => {
  return (
    <section className="bg-white border border-slate-100 rounded-xl shadow-sm p-6 space-y-3">
      <h2 className="text-lg font-semibold text-slate-900">General Ledger</h2>
      <p className="text-sm text-slate-600">Maintain complete accounting records including receivables, payables, and petty cash transactions.</p>
      <ul className="text-sm text-slate-700 list-disc list-inside space-y-1">
        <li>Post transactions to chart of accounts</li>
        <li>Capture petty cash expenses with references</li>
        <li>Prepare account balances for financial reporting</li>
      </ul>
    </section>
  );
};

export default AccountingGeneralLedgerTab;
